import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    padding: calc(var(--padding-base) / 2);
    width: 100%;
    position: relative;

    background: #ffffff;
    box-shadow: var(--box-shadow);
    border-radius: 8px;
    gap: 0.5rem;

    > aside {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;
        justify-content: flex-start;
        margin: 0.5rem;
    }

    > main {
        flex: 5;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        height: 100%;
        width: 100%;

        > header {
            width: 100%;

            h2 {
                font-size: 1.1rem;
                padding-bottom: 0.5rem;
                color: var(--color-text);
            }
        }

        > footer {
            margin-top: 1rem;
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;

            > button {
                margin-left: 0.5rem;
            }
        }
    }
`;

export const Mark = styled.div`
    position: absolute;
    top: -0.1rem;
    right: 0.2rem;
`;
